/**
 * #### Decisyon Srl ####
 * Author 	: Pagano Francesco
 * Date 	: 22.10.15 
 */

(function() {
	'use strict';
	
	function BreadCrumbController($scope, $element, $attrs, dcyUtilsFactory, dcyNavigationManagerUtilsFactory, dcyNavigationManagerStatusFactory) {

		var ngModel 	= $element.controller('ngModel');
		
		this.isFolder 	= dcyNavigationManagerUtilsFactory.isFolder;
		
		this.getViewModel = function(filter){
			if(dcyUtilsFactory.isValidObject(ngModel.$viewValue)){
				
				var filterSplitted = filter.split('.'),
					viewModel = new Array(),
					currentFilter = '';
				
				for(var i=0; i < filterSplitted.length; i++){
					var relativeFilter = filterSplitted[i];

					currentFilter = dcyUtilsFactory.isValidString(currentFilter) ? currentFilter+'.'+ relativeFilter : relativeFilter;
					
					if(angular.equals(relativeFilter, 'nodes') || (this.viewRootData == 'false' && currentFilter == 'root')){
						continue;
					}
					
					var relativeData = _.get(ngModel.$viewValue, currentFilter);
					
					if(relativeData && this.isFolder(relativeData.type)){
						viewModel.push(relativeData);
					}
				}
				
				return viewModel;
			}
			
			return undefined;
		};
		
		this.onMouseDown = function($event, node){
			var nodeInfo = node.nodeInfo;
			dcyNavigationManagerStatusFactory.removeSelected(ngModel.$viewValue);
			dcyNavigationManagerStatusFactory.removeVisited(ngModel.$viewValue);
			nodeInfo.selected = true;
			nodeInfo.expanded = true;
			nodeInfo.visited = true;
			$scope.filter = nodeInfo.filter;

			if(dcyUtilsFactory.isValidObject($scope.callbacks) && angular.isFunction($scope.callbacks.onMouseDown)){
				$scope.callbacks.onMouseDown($event, node);
			}
		};
		
		/**
		 * Inizialize attributes
		 * # viewRootData 	: enable/disable show root data
		 * # viewFiles 		: enable/disable show files
		 */
		this.initAttributes = function(tAttrs){
			this.viewRootData	= tAttrs.viewRootData;
		};
		
		/**
		 * Manage ngModel for generate data and status service
		 */
		this.initModelData = function(){
			ngModel.$render = function () {
				if(dcyUtilsFactory.isValidObject(ngModel.$viewValue)){
					$scope.filter = $scope.filter ? $scope.filter : Object.keys(ngModel.$viewValue)[0];
					$scope.dcyBreadCrumbCtrl.currentViewModelData = $scope.dcyBreadCrumbCtrl.getViewModel($scope.filter);
				}
			};
		};
		
		this.init = function(ngModel, tAttrs){
			this.initAttributes(tAttrs);
			this.initModelData();
		};
	};

	BreadCrumbController.$inject = ['$scope', '$element', '$attrs', 'dcyUtilsFactory', 'dcyNavigationManagerUtilsFactory', 'dcyNavigationManagerStatusFactory'];

	function DcyBreadCrumbDirective(dcyUtilsFactory, $compile, dcyNavigationManagerStatusFactory) {
		return {
			restrict: 'E',
			require : 'ngModel',
			scope: {
				callbacks	 : '=callbacks',
				filter	     : '=filter'
			},
			templateUrl : '../../jsLib/devel/modules/components/navigation/breadcrumb/breadcrumb.template.html',
			controller	: BreadCrumbController,
			controllerAs: 'dcyBreadCrumbCtrl',
			compile: function compile() {
				return {
					pre: function preCompile(scope, tElement, tAttrs, ngModel) {
						scope.dcyBreadCrumbCtrl.init(ngModel, tAttrs);
						tAttrs.$observe('viewRootData', function(viewRootData) {
							scope.dcyBreadCrumbCtrl.viewRootData = viewRootData;
						});
					},	
					post: function postCompile(scope, iElement, iAttrs, ngModel) {
						//Conterr� tutte le function inerenti allo spegnimento dei watch
						var unbindWatches = new Array();
						
						//##########################################################
						// Mi metto in ascolto di eventuali cambiamenti dei settings
						//##########################################################
						unbindWatches.push(scope.$watch('filter', function(newValue, oldValue){
							if(!angular.equals(newValue, oldValue) && oldValue != undefined){
								scope.dcyBreadCrumbCtrl.currentViewModelData = scope.dcyBreadCrumbCtrl.getViewModel(newValue);
								if(dcyUtilsFactory.isValidObject(scope.callbacks) && angular.isFunction(scope.callbacks.onFilterChange)){
									scope.callbacks.onFilterChange(scope.dcyBreadCrumbCtrl.currentViewModelData, scope.dcyBreadCrumbCtrl.currentViewModelData[scope.dcyBreadCrumbCtrl.currentViewModelData.length-1].nodeInfo, newValue);
								}
							}
						}));
						
						//Distruzione dei watch e dello scope stesso nel caso
						//di distruzione dell'elemento Dom.
						scope.$on('$destroy', function () {
				            for(var i = 0; i < unbindWatches.length; i++){
								unbindWatches[i]();
							}
				        });
					}	
				};
			}				
		};
	}

	DcyBreadCrumbDirective.$inject = ['dcyUtilsFactory', '$compile', 'dcyNavigationManagerStatusFactory'];
	angular.module('dcyApp').register.directive('dcyBreadCrumb', DcyBreadCrumbDirective);
	
}());